import SupportForm from '../../components/Support/Form'
import SupportModal from '../../components/reusable/Modals/InfoModals/SupportModal'
import Subtitle from '../../components/reusable/Titles/Subtitle'
import Title from '../../components/reusable/Titles/Title'

const Support = () => {
  return (
    <div className="support_page wrapper_1055">
      <Title title="Служба підтримки користувачів" />
      <Subtitle title="Питання, скарги та пропозиції" />
      <SupportForm />
      <SupportModal />
    </div>
  )
}

export default Support
